import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './ProductDetails.css';
import { vouchers } from '../data/vouchersData';
 
 

export default function VoucherDetails() {
  const { id } = useParams();
  const voucher = vouchers.find(v => v.id === parseInt(id));

  if (!voucher) {
    return (
      <div className="product-not-found">
        <div className="container">
          <h2>Voucher Not Found</h2>
          <Link to="/voucher" className="btn btn-primary">Back to Vouchers</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="product-details-page">
      <div className="product-details section">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/voucher">Vouchers</Link> / {voucher.title}
          </div>
          <div className="product-details-grid">
            {/* Left: Image */}
            <div className="product-images">
              <div className="main-image-voucher">
                <img src={voucher.image_en} alt={voucher.title} />
                <img src={voucher.image_om} alt={voucher.title} />
              </div>
            </div>
            {/* Right: Info */}
            <div className="product-info">
              <div className="product-category">Voucher</div>
              <h1 className="product-title">{voucher.title}</h1>
              <div className="product-brand">
                <span>Voucher Code: {voucher.code}</span>
              </div>
              <div className="product-description">
              <p className='voucher-washes'>{voucher.washes}</p>
              
              </div>
              <div>
              <p className='voucher-description'>{voucher.description}</p>
              </div>
              
              <div className="product-details-section">
                <h3>Eco-Friendly Cleaning for Your Vehicle – Prepaid and Convenient!</h3>
                <div className="details-content">
                  <p>Discover the future of car care with GreenKleen's Waterless Car Wash Coupon Booklet. Our innovative, environmentally conscious service uses advanced waterless technology to deliver a spotless exterior clean without wasting a single drop of water. Perfect for busy lifestyles, this prepaid booklet contains <strong>15 redeemable coupons</strong> for exterior-only car washes, valid at any of our <strong>13 convenient outlets</strong> across the region.  </p>
                  
                  <p>Each coupon entitles you to one professional exterior waterless car wash, ensuring your vehicle stays shining and protected. Whether you're maintaining your daily driver or prepping for a road trip, GreenKleen's service is quick, effective, and planet-friendly – saving thousands of liters of water per wash!</p>
                </div>
              </div>
              <div className="product-details-section">
                <h3>Key Features</h3>
                <div className="details-content">
                  <ul>
                    <li><strong>Waterless Technology</strong>: No hoses, no runoff – just a thorough clean using safe, biodegradable products.</li>
                    <li><strong>15 Coupons per Booklet</strong>: Great value for frequent users; use them at your pace.</li>
                    <li><strong>Exterior Focus</strong>: Includes body, wheels, and windows for a complete outside refresh.</li>
                    <li><strong>Redeem Anywhere</strong>: Valid at all 13 GreenKleen locations for ultimate flexibility.</li>
                    <li><strong>Eco-Commitment</strong>: Support sustainability with every wash – our process conserves water and reduces environmental impact.</li>
                  </ul>
                  <p>Simply purchase the booklet online, receive it via delivery or pickup, and punch out a coupon during your next visit. No expiration date means you can use them whenever it suits you!</p>
                </div>
              </div>
              <div className="product-actions">
                <a 
                  href={`https://wa.me/96898520852?text=I%20am%20interested%20in%20this%20product:%20${encodeURIComponent(voucher.title)}`}
                  className="btn btn-secondary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp"></i> Inquire on WhatsApp
                </a>
                <Link to="/loyalty-program" className="btn btn-outline">
                  Back to Vouchers
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Full-width sections below details grid */}
      <div className="product-details section voucher-extra-section" style={{marginTop: '2rem'}}>
        <div className="container">
          <div className="product-details-section">
            <h3>Why Choose GreenKleen?</h3>
            <div className="details-content">
              <ul>
                <li>Trusted by thousands for reliable, high-quality service.</li>
                <li>Hassle-free redemption – no appointments needed at most outlets.</li>
                <li>Perfect gift for car enthusiasts or as a corporate perk.</li>
              </ul>
              <p><strong>Add to cart today and keep your car looking pristine the green way!</strong></p>
            </div>
          </div>
          <div className="product-details-section">
            <h3>Terms and Conditions</h3>
            <div className="details-content">
              <ol>
                <li><strong>Service Scope</strong>: This booklet is valid for exterior car washing services only. Interior cleaning is not included.</li>
                <li><strong>Redemption</strong>: Coupons can be redeemed at any of the 13 GreenKleen outlets. Present the booklet and allow staff to punch the coupon upon service completion.</li>
                <li><strong>Vehicle Categories</strong>: The Green Booklet is exclusively for SUVs and 4x4 vehicles; the Blue Booklet is for Saloon (sedan) cars. Using the incorrect booklet may result in additional charges or service denial.</li>
                <li><strong>Coupon Count Verification</strong>: Please count the number of leaflets (coupons) in the booklet upon purchase or receipt. Any complaints regarding the number of coupons after purchase will not be entertained.</li>
                <li><strong>Liability Disclaimer</strong>: Service is rendered for car washing only. GreenKleen will not be liable for any loss, fire, theft, or damages in any case. We will assume liability only in the event that negligence is found on our side. The holder of this booklet accepts, agrees, and acknowledges this disclaimer.</li>
                <li><strong>Non-Transferable</strong>: Coupons are non-transferable and cannot be exchanged for cash or other services.</li>
                <li><strong>Validity</strong>: No expiration date, but coupons must be used in sequence as punched.</li>
                <li><strong>Refunds and Exchanges</strong>: Booklets are non-refundable and non-exchangeable once purchased.</li>
                <li><strong>Amendments</strong>: GreenKleen reserves the right to amend these terms and conditions without prior notice.</li>
              </ol>
              <p>For any inquiries, contact our customer support at <a href="mailto:contactus@greenkleenoman.com">contactus@greenkleenoman.com</a> or visit our website. Drive clean, stay green!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 